import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { BasePage } from 'src/pages/base.page';
import { LoginViewModel } from 'src/pages/login/LoginViewModel';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { AlertController, LoadingController, ToastController, MenuController, NavController } from '@ionic/angular';

import { LoadingComponent } from 'projects/core/src/lib/core/Loading.component';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { LoginModel } from 'projects/core/src/lib/core/model/LoginModel';
import { EsqueciMinhaSenhaViewModel } from './EsqueciMinhaSenhaViewModel';
import { EsqueciMinhaSenhaModel } from 'projects/core/src/lib/core/model/EsqueciMinhaSenhaModel';

@Component({
  selector: 'esqueci-minha-senha-page',
  templateUrl: 'esqueci-minha-senha.page.html',
  styleUrls: ['esqueci-minha-senha.page.scss']
})
export class EsqueciMinhaSenhaPage extends BasePage {

    constructor(
      public router: Router, 
      private loadingController: LoadingController,
      public toastCtrl: ToastController,
      public menuCtrl: MenuController,
      public navCtrl: NavController) {
      super(router)
    }
    
    alertComponent: AlertComponent
    loadingComponent: LoadingComponent
    loginModel: LoginModel
    loginViewModel: LoginViewModel
    esqueciMinhaSenhaViewModel: EsqueciMinhaSenhaViewModel
    esqueciMinhaSenhaModel: EsqueciMinhaSenhaModel

    ngOnInit() {
      this.iniciaVariaveis()
      this.menuCtrl.enable(false)
      this.configuraTeclado()
    }

    configuraTeclado() {
      let html = document.getElementsByTagName("html")[0];
      window.addEventListener('native.keyboardshow', (e) => {
        console.log("show2");
        html.style.height = "auto";
        //this.renderer2.setStyle(html, 'height', '101vh');
      }); 
      window.addEventListener('native.keyboardhide', () => {
        console.log("hide2");
        html.style.height = "101vh";
        //this.renderer2.setStyle(html, 'height', 'auto');
      });
    }

    iniciaVariaveis() {
      this.loginModel = new LoginModel()
      this.loadingComponent = new LoadingComponent(this.loadingController)
      this.esqueciMinhaSenhaViewModel = new EsqueciMinhaSenhaViewModel()
      this.esqueciMinhaSenhaViewModel.setContext(this)
      this.esqueciMinhaSenhaModel = new EsqueciMinhaSenhaModel()
    }

    async enviaEsqueciMinhaSenha() {
      const loading = await this.showLoading()
      try {
        await this.esqueciMinhaSenhaViewModel.enviaEsqueciMinhaSenha(this.esqueciMinhaSenhaModel)
      } catch (e) {
        AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, ThrowError.MESSAGE_DEFAULT)
      }
      if (loading != null) {
        loading.dismiss()
      }
    }

    async showLoading() {
      return await this.loadingComponent.showLoading()
    }

    retornoSucessoEsqueciMinhaSenha(message: string) {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, message);
      this.navCtrl.pop()
    }

    retornoFalhaEsqueciMinhaSenha(message: string) {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, message);
    }

    retornoErroEsqueciMinhaSenha(message: string) {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, message);
    }

    validaEmailEsqueciMinhaSenha() {
      if (!this.esqueciMinhaSenhaModel.email || this.esqueciMinhaSenhaModel.email == '') {
        AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'É preciso preencher o campo "e-mail" para recuperar sua senha')
        return false;
      }
      
      if (!this.esqueciMinhaSenhaViewModel.validateEmail(this.esqueciMinhaSenhaModel.email)) {
        AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'Endereço de e-mail inválido')
        return false;
      }
      return true;
    }

    btnEnviarRecuperarSenha() {
      if (this.validaEmailEsqueciMinhaSenha()) {
        this.enviaEsqueciMinhaSenha();
      }
    }

    btnVoltarLogin() {
      this.navCtrl.pop()
    }
}